import TokenStore from './token_store.js'

class WreckAPI {
  static create_account(data) {
    return TokenStore.get()
      .then((token) => this.post('upgrade_to_free_account.json', {'Authorization': 'Bearer ' + token}, data))
      .then((data) => TokenStore.renew())
  }

  static login(data) {
    return TokenStore.get()
      .then((token) => this.post('reclaim_account.json', {'Authorization': 'Bearer ' + token}, data))
      .then((data) => TokenStore.renew())
  }

  static purchase(data) {
    return TokenStore.get()
      .then((token) => this.post('confirm_purchase.json', {'Authorization': 'Bearer ' + token}, data))
      .then((data) => TokenStore.renew())
  }

  static getWrecks(packName) {
    return TokenStore.get()
      .then((token) => this.get('wrecks_in_area_pack.json?name='+packName, {'Authorization': 'Bearer ' + token}))
  }

  // -----

  static post(endpoint, headers, data) {
    return this.request('POST', endpoint, headers, JSON.stringify(data))
  }

  static get(endpoint, headers) {
    return this.request('GET', endpoint, headers, null)
  }

  static request(method, endpoint, headers, body) {
    const apiBaseURI = process.env.REACT_APP_API_HOST

    const ajaxOptions = {
      method: method,
      headers: {
        ...headers,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: body
    }
    return fetch(apiBaseURI + endpoint, ajaxOptions)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          return response.json().then((json) => { throw json } );
        }
      })
      .catch((data) => {
        if (data.error === "Invalid bearer token") {
          return TokenStore.reset().then((token) => {
            throw data
          })
        } else {
          throw data
        }
      })
  }
}

export default WreckAPI;



// WEBPACK FOOTER //
// ./src/lib/wreck_api.js